export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/noop.js
// module id = 84
// module chunks = 0